import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
//#region src/lib/utils.ts
function cn(...inputs) {
	return twMerge(clsx(inputs));
}
/**
* Checks if an error string, ReactNode, or array of errors has any non-empty errors
*/
const hasErrors = (errors) => {
	if (!errors) return false;
	if (typeof errors === "string") return errors.trim().length > 0;
	if (Array.isArray(errors)) return errors.some((error) => {
		if (error == null) return false;
		if (typeof error === "string") return error.trim().length > 0;
		return Boolean(error);
	});
	return Boolean(errors);
};
//#endregion
export { cn, hasErrors };

//# sourceMappingURL=utils.js.map